import { z } from 'zod';

export const startActivitySchema = z.object({
  taskId: z.number({ required_error: 'Task is required', invalid_type_error: 'Task is required' }),
  description: z.string().optional(),
});

export type StartActivityFormValues = z.infer<typeof startActivitySchema>;

